import React from "react";
import useDialogState from "../../hooks/useDialog";
import { enqueueSnackbar } from "notistack";
import * as XLSX from "xlsx";
import { useState } from "react";
import { Button, Card, Col } from "react-bootstrap";
import { DeleteAllRaceResult, UploadRaceExcelFile } from "../modals/allModal";
import { useFormik } from "formik";
import {
  PredictUserTable,
  RacePlayerTable,
  RaceTable,
} from "../allTables/allTable";
import * as yup from "yup";
import { useLocation } from "react-router-dom";
import RaceService from "../../services/race.service";
import { useEffect } from "react";
import { Grid } from "@mui/material";
import moment from "moment";
import CountryService from "../../services/country.service";
import useMenuState from "../../hooks/useMenuState";

const schema = yup.object().shape({
  data: yup.mixed().required("Please Upload Your Data"),
});

const RaceExcelUpload = () => {
  const [data, setData] = useState([]);
  const [player, setPlayer] = useState([]);
  const [predictionList, setPredictionList] = useState([]);
  const [downloadPredictionList, setDownloadPredictionList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingResult, setIsLoadingResult] = useState(false);
  const [isLoadingPlayer, setIsLoadingPlayer] = useState(false);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [dataPerPageResult, setDataPerPageResult] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalRows, setTotalRows] = useState("");
  const [totalRecord, setTotalRecord] = useState("");
  const [newData, setNewData] = useState([]);
  const [modalDelete, setModalDelete] = useState(false);
  const handleHighScoreClose = () => setModalDelete(false);
  const [progress, setProgress] = useState(0);
  const [loader, setLoader] = useState(false);
  const location = useLocation();
  const selectedType = location?.search?.split("=")[1];
  const id = location?.state?.id;
  const spotify = location?.state?.spotify;
  const countryFlag = location?.state?.image;
  const countryName = location?.state?.name;
  const countryYear = location?.state?.year;
  const race = location?.state?.race;
  const status = location?.state?.teamStatus;
  const {
    open: modalShow,
    handleClickOpen: handleDialogOpen,
    handleClose: handleDialogClose,
  } = useDialogState();
  const [search, setSearch] = useState("");
  const [countryData, setCountryData] = useState([]);
  const [openCity, handleOpenCity, handleCloseCity] = useMenuState(false);


  const getPlayer = async () => {
    setIsLoadingPlayer(true);
    try {
      const response = await RaceService.GetSingleRace(id);
      const DownloadPredictionList = await RaceService.DownloadPredictionList(
        id
      );
      setDownloadPredictionList(DownloadPredictionList.data.data);
      setPlayer(response.data.data.playerDetail);
    } catch (error) {
      console.error("error", error);
    } finally {
      setIsLoadingPlayer(false);
    }
  };

  const getPredicationList = async () => {
    setIsLoading(true);
    try {
      const predictionList = await RaceService.PredictionList(
        id,
        pageNumber,
        dataPerPage
      );
      setPredictionList(predictionList.data.data);
      setTotalRows(predictionList.data.TotalCount);
    } catch (error) {
      console.error("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getAllResult = async (page) => {
    setIsLoadingResult(true);
    const response = await RaceService.raceAllResult(
      id,
      page,
      dataPerPageResult,
      search,
      selectedType?.toUpperCase()
    );
    setIsLoadingResult(false);
    const result = response.data.data;
    let newData = [];

    if (Array.isArray(result) && result.length > 0) {
      if (result[0].raceDetail) {
        const raceDetail = result[0].raceDetail;
        if (
          !result.some(
            (item) => JSON.stringify(item) === JSON.stringify({ raceDetail })
          )
        ) {
          newData = [{ playerRaceDetail: raceDetail }, ...result];
        }
      } else {
        newData = result.slice(1);
      }
    } else {
      newData = result;
    }

    setData(newData);
    setTotalRecord(response.data.totalCount + 1);
  };

  useEffect(() => {
    getAllResult();
  }, [dataPerPageResult, search]);

  const handlePerPageChange = async (newPerPage, newPageNumber) => {
    setIsLoading(true);
    setDataPerPage(newPerPage);
    setPageNumber(newPageNumber);
    getPlayer();
    setIsLoading(false);
    await predictionList();
  };

  const handlePageChange = async (newPageNumber) => {
    setIsLoading(true);
    setPageNumber(newPageNumber);
    getPlayer();
    setIsLoading(false);
    await predictionList();
  };

  const handlePerPageChangeResult = async (newPerPage, newPageNumber) => {
    setIsLoadingResult(true);
    setDataPerPageResult(newPerPage);
    await getAllResult();
    setIsLoadingResult(false);
  };

  const handlePageChangeResult = async (newPageNumber) => {
    setIsLoadingResult(true);
    await getAllResult(newPageNumber);
    setIsLoadingResult(false);
  };

  useEffect(() => {
    getPlayer();
  }, []);

  useEffect(() => {
    getPredicationList();
  }, [pageNumber, dataPerPage]);

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];

    if (!file || !file.name.endsWith(".xlsx")) {
      enqueueSnackbar(
        "Invalid File Type! Only Excel files (XLSX) are allowed.",
        {
          variant: "error",
        }
      );
      return;
    }

    const reader = new FileReader();

    reader.onload = async function (e) {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
      formik.setFieldValue("data", sheetData);
    };

    reader.readAsArrayBuffer(file);
  };

  const initialValue = {
    data: "",
  };
  const submit = async (values, action) => {
    try {
      setLoader(true);
      const sheetData = values.data;
      const chunkSize = 50;
      const headerRow = sheetData[0]; // Extract the first row as header
      const totalChunks = Math.ceil(sheetData.length / chunkSize);
      for (let i = 0; i < sheetData.length; i += chunkSize) {
        const chunk =
          i === 0
            ? sheetData.slice(i, i + chunkSize)
            : [headerRow, ...sheetData.slice(i, i + chunkSize)]; // Prepend header to each chunk
        try {
          await RaceService.raceResult({
            data: chunk,
            raceId: id,
            type: selectedType?.toUpperCase(),
          });
          setProgress(((i + chunkSize) / sheetData.length) * 100);
        } catch (error) {
          enqueueSnackbar("Error uploading batch: " + (i / chunkSize + 1), {
            variant: "error",
          });
          setLoader(false);
          handleDialogClose();
        }
      }

      // const response = await RaceService.raceResult(values);
      handleDialogClose();
      setLoader(false);
      getAllResult();
      action.resetForm();
      formik.resetForm();
    } catch (error) {
      console.error("create race error", error);
    } finally {
      setLoader(false);
    }
  };

  const handleData = (e) => {
    setSearch(e.target.value);
  };

  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: schema,
    onSubmit: submit,
  });

  const handleGetdata = (data) => {
    setNewData(data);
  };

  const exportToExcel = () => {
    if (isLoadingPlayer || downloadPredictionList?.length === 0) return;
    const formattedData = [];

    downloadPredictionList.forEach((item) => {
      const date = moment(item.createdAt).format("DD-MM-YYYY HH:mm");
      const userData = {
        COUNTRY: countryName,
        COUNTRY_YEAR: countryYear,
        UNIQUE_CODE: item.uniqueCode,
        USER_NAME: item.userName,
        FIRST_NAME: item.firstName,
        LAST_NAME: item.lastName,
        MOBILE_NUMBER: item.mobileNumber,
        EMAIL: item.email,
        TIME_STAMP: date,
      };
      item.raceDetail.forEach((raceItem) => {
        const question = raceItem.question;

        // const mergedAnswer = raceItem?.answer?.join("(") + ")" || "";

        const mergedAnswer = raceItem?.answer?.length > 0 ?
          raceItem?.answer?.[1] ?
            `${raceItem?.answer?.[0]}(${raceItem?.answer?.[1]})` :
            raceItem?.answer?.[0]
          : "";

        const existingUser = formattedData.find(
          (data) => data.USER_NAME === item.userName
        );
        if (existingUser) {
          existingUser[question] = mergedAnswer;
        } else {
          userData[question] = mergedAnswer;
          formattedData.push(userData);
        }
      });
    });

    const worksheet = XLSX.utils.json_to_sheet(formattedData);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    const filename = "race_data.xlsx";
    XLSX.writeFile(workbook, filename);
  };

  const handleResult = () => {
    handleDialogOpen();
    formik.setFieldValue("raceId", id);
    formik.setFieldValue("data", "");
  };

  const handleDelete = () => {
    setModalDelete(true);
  };

  const getCountryList = async () => {
    const response = await CountryService.GetCountryListForRace();
    setCountryData(response.data.data);
  };

  useEffect(() => {
    getCountryList();
  }, []);

  const contryStatus = [
    ...countryData.map((item) => ({
      value: item._id,
      label: item.countryName,
    })),
  ];


  const changeCountry = (value) => {
    formik.setFieldValue("playerCountryName", value.label);
    // setSearchText(value);
  };

  return (
    <>
      <div className="page-header2"></div>
      <div
        className="flexi"
        style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
        <Grid>
          <Card
            className="custom-card pointer"
            style={{ height: "232px", width: "350px" }}>
            <img
              src={countryFlag}
              className="rounded-lg img-fit-cover pos-relative"
              alt="img"
            />

            <Card.Body className="pos-absolute card-body2">
              <div className="card-order bg-000">
                <label className="main-content-label font-weight-bold mb-0 pointer">
                  {race} - {countryName} - {countryYear}
                </label>
              </div>
            </Card.Body>
          </Card>
        </Grid>
        <Grid>
          <div style={{ width: "100%", maxWidth: "500px", height: "250px", marginLeft: "30px" }}>
            <iframe
              title="Spotify Embed"
              width="100%"
              height="100%"
              src={spotify}
              frameBorder="0"
              allowtransparency="true"
              allow="encrypted-media"></iframe>
          </div>
        </Grid>
      </div>
      <RacePlayerTable
        setIsLoadingPlayer={setIsLoadingPlayer}
        setPlayer={setPlayer}
        getPlayer={getPlayer}
        data={player}
        contryStatus={contryStatus}
        changeCountry={changeCountry}
        openCity={openCity}
        handleOpenCity={handleOpenCity}
        handleCloseCity={handleCloseCity}
        selectedType={selectedType}
        isLoadingPlayer={isLoadingPlayer}
        sendData={handleGetdata}
        singleId={id}
        handleData={handleData}
      />
      <div className="row">
        <Col sm={12} md={6} lg={6} xl={4} className="ms-auto mt-auto">
          <div
            className="custom-card text-end  pointer"
            style={{ marginRight: "18px" }}>
            <Button
              className="text-white"
              onClick={exportToExcel}
              disabled={
                isLoadingPlayer || downloadPredictionList?.length === 0
              }>
              <i className="fas fa-download"></i> &nbsp; Download Prediction
              List
            </Button>
          </div>
        </Col>
      </div>
      <PredictUserTable
        data={predictionList}
        singleId={id}
        dataPerPage={dataPerPage}
        totalRows={totalRows}
        handlePerPageChange={handlePerPageChange}
        handlePageChange={handlePageChange}
        isLoading={isLoading}
        status={status}
      />
      <div className="row">
        <Col sm={12} md={6} lg={6} xl={4} className="ms-auto mt-auto">
          <div
            className="custom-card text-end  pointer"
            style={{ marginRight: "18px" }}>
            <div style={{ display: "flex", justifyContent: "end" }}>
              {data.length === 0 && (
                <>
                  <Button
                    className="text-white"
                    onClick={() => handleResult("")}>
                    <i className="fas fa-plus"></i> &nbsp; Upload Race Result
                  </Button>
                  <UploadRaceExcelFile
                    show={modalShow}
                    onHide={handleDialogClose}
                    progress={progress}
                    formik={formik}
                    loader={loader}
                    type="country"
                    showFileToSingleUpload={handleFileUpload}
                    status={status}
                  />
                </>
              )}
              {data.length !== 0 && (
                <>
                  <Button
                    className="text-white"
                    variant="danger"
                    style={{ marginBottom: "5px", marginLeft: "15px" }}
                    onClick={() => handleDelete("")}>
                    <i className="fas fa-trash"></i> &nbsp; Delete All Data
                  </Button>
                  {modalDelete && (
                    <DeleteAllRaceResult
                      show={modalDelete}
                      id={id}
                      onHide={handleHighScoreClose}
                      getAllHighScore={getAllResult}
                      type="countries"
                    />
                  )}
                </>
              )}
            </div>
          </div>
        </Col>
      </div>
      <RaceTable
        data={data}
        dataPerPage={dataPerPageResult}
        totalRows={totalRecord}
        handlePerPageChange={handlePerPageChangeResult}
        handlePageChange={handlePageChangeResult}
        isLoading={isLoadingResult}
        getAllResult={getAllResult}
        status={status}
      />
    </>
  );
};

export default RaceExcelUpload;
